module.exports = __webpack_public_path__ + "img/BookBank.601ebb31.png";